import { Age } from 'lib/models/diagnoses/choices/epidemiology/age';
import React, { HTMLProps, useMemo } from 'react';

type RaritySelectorProps = {
  value: Age;
  id?: string;
  name?: string;
  tabIndex?: number;
  disabledAges?: Age[];
  onChange: (age: Age) => void;
} & Omit<HTMLProps<HTMLSelectElement>, 'onChange' | 'value'>;

export const AgeSelector: React.FC<RaritySelectorProps> = ({
  value,
  disabledAges,
  onChange,
  ...props
}) => {
  const AGES = useMemo(
    () =>
      Age.values().map((item) => ({
        age: item,
        label: item.label
      })),
    []
  );

  const disabledSet = new Set<number>();
  (disabledAges || []).forEach((age) => disabledSet.add(age.id));

  return (
    <select
      {...props}
      value={value.id}
      onChange={(e) => onChange(Age.fromTag(parseInt(e.target.value, 10)))}
    >
      {AGES.map((item) => (
        <option
          key={item.age.id}
          value={item.age.id}
          disabled={disabledSet.has(item.age.id) && item.age.id !== value.id}
        >
          {item.label}
        </option>
      ))}
    </select>
  );
};
